import React from "react";
import { Link } from "react-router-dom";

/**
 * Shared loading / empty / error message block (styles in index.css).
 * kind: "empty" | "loading" | "error"
 */
export default function StateMessage({
  kind = "empty",
  title,
  children,
  linkTo,
  linkLabel,
  plain = false,
}) {
  const classes = [
    "ui-state",
    kind === "error" ? "ui-state--error" : "",
    plain ? "ui-state--plain" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={classes}
      role={kind === "error" ? "alert" : kind === "loading" ? "status" : undefined}
    >
      {title && <p className="ui-state-title">{title}</p>}
      {children && <p>{children}</p>}
      {linkTo && linkLabel && (
        <Link to={linkTo} className="ui-state-link">
          {linkLabel} →
        </Link>
      )}
    </div>
  );
}
